import { cn } from '@/lib/utils';
import dayjs from 'dayjs';
import { Badge } from './badge';

export type VehicleListingTimeStatusBadgeProps = {
  dateString: string;
  className?: string;
};

export const VehicleListingTimeStatusBadge = ({
  dateString,
  className,
}: VehicleListingTimeStatusBadgeProps) => {
  // listing created within the last 7 days using dayjs
  const isUnder7DaysOld = dayjs(dateString).isAfter(
    dayjs().subtract(7, 'days'),
  );
  if (isUnder7DaysOld) {
    return (
      <Badge
        className={cn('text-xs bg-green-500 text-white', className)}
        variant="outline"
      >
        New
      </Badge>
    );
  }

  // if the listing is over 30 days old, show a badge
  const isOver30DaysOldAndUnder45DaysOld =
    dayjs(dateString).isBefore(dayjs().subtract(45, 'days')) &&
    dayjs(dateString).isAfter(dayjs().subtract(30, 'days'));
  if (isOver30DaysOldAndUnder45DaysOld) {
    return (
      <Badge
        className={cn('text-xs bg-orange-500 text-white', className)}
        variant="outline"
      >
        30+ days
      </Badge>
    );
  }

  // if the listing is over 45 days old, show a badge
  const isOver45DaysOld = dayjs(dateString).isBefore(
    dayjs().subtract(45, 'days'),
  );
  if (isOver45DaysOld) {
    return (
      <Badge
        className={cn('text-xs bg-red-500 text-white', className)}
        variant="outline"
      >
        45+ days
      </Badge>
    );
  }

  return null;
};
